import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportManagerService } from '../../services/report-manager.service';
import { ReportList } from 'src/app/Modules/informate/models/reports/data-sheet-report.model';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { EnvironmentService } from 'src/app/services/environment.service';
@Component({
    selector: 'app-reports-data',
    templateUrl: './reports-data.component.html',
    styleUrls: ['./reports-data.component.scss'],
})
export class ReportsDataComponent {
    @Input()
    get reportData(): ReportList[] {
        return this._reportData;
    }
    set reportData(value: ReportList[]) {
        this._reportData = value;
        if (value && !this.searchText) {
            this.reportDataCopy = this.reportData;
            this.reportData.sort((a, b) => {
                if (a.isFavourite === b.isFavourite) {
                    return 0;
                }

                if (a.isFavourite) {
                    return -1;
                }

                if (b.isFavourite) {
                    return 1;
                }
            });
        }
    }
    @Input() type: string;
    @Output() changeIsfavourite = new EventEmitter<any>();

    _reportData: ReportList[];
    searchText = '';
    reportDataCopy: ReportList[];
    showDevButton = false;
    addSubscription: boolean = false;

    constructor(
        private reportManagerService: ReportManagerService,
        private router: Router,
        private userUtilityService: UserUtilityService,
        private EnvironmentService: EnvironmentService
    ) {}

    async ngOnInit(): Promise<void> {
        this.showDevButton = environment.showDevButton;
        this.addSubscription = await this.userUtilityService.checkUserPermissionDataAndRoute('Reports-Scheduling', userActions.Create);
    }

    reportView(report: any): void {
        const res = {
            type: 'viewReport',
            reportName: report.name,
            reportId: report.reportId,
            supportedFileTypes: report.supportedFileTypes,
        };

        this.reportManagerService._selectedView.next(res);
        // this.reportManagerService.isReportSelected.next(reportName);
    }

    searchResult(event) {
        if (!event.target.value) {
            this.reportData = this.reportDataCopy;
        } else {
            this.reportData = this.reportDataCopy.filter((item) => {
                return (item.name !== undefined ? item.name : '')
                    .trim()
                    .toLowerCase()
                    .replace(' ', '')
                    .includes(event.target.value.trim().replace(' ', '').toLowerCase());
            });
        }
        this.reportData.sort((a, b) => {
            if (a.isFavourite === b.isFavourite) {
                return 0;
            }

            if (a.isFavourite) {
                return -1;
            }

            if (b.isFavourite) {
                return 1;
            }
        });
    }

    SetFavourite(data: ReportList) {
        const params = {
            entityId: data.reportId,
            active: data.isFavourite == true ? false : true,
        };
        this.changeIsfavourite.emit(params);
    }

    scheduleReport(report: any) {
        const res = {
            type: 'viewSubscription',
            reportName: report.name,
            reportId: report.reportId,
            supportedFileTypes: report.supportedFileTypes,
        };
        this.reportManagerService._selectedView.next(res);
        // let dialogRef = this.modelService.open(ScheduleReportsComponent, {
        //     size: 'lg',
        //     backdrop: 'static',
        // });
        // dialogRef.componentInstance.reportName = reportName;
    }

    addReport() {
        this.router
            .navigate(['idms', 'reports', 'add'])
            .then((r) => {})
            .catch((err) => {
                console.warn(err);
            });
    }
}
